var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$can('See.Frs.ExperimentalFeatures'))?_c('div',{staticClass:"experimental-feature"},[_c('div',{staticClass:"ribbon"},[_vm._v("\n    BETA\n  ")]),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }